// extracted by mini-css-extract-plugin
module.exports = {"title":"options_title__Ws-8p","card":"options_card__2AY7U","h5":"options_h5__Tf50M","text":"options_text__3duiB","images":"options_images__2FsD_","container":"options_container__3tOcI","content":"options_content__3tK_Q"};
    if(module.hot) {
      // 1783592032000
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  